<div class="extend-container">
  <div class="extend-container-header">
    <div class="extend-container-header-title">Extension Request</div>
    <img matDialogClose src="assets/images/close.svg" alt="">
  </div>
  <div class="extend-container-main-container">
    <div class="extend-container-main-deadline-container">
      <div>Current Deadline - </div>
      <div>{{data.projectDetails.evaluator_target_date | dateFormat}}<span>({{data.projectDetails.evaluator_target_date | dateToRemainingDays | absoluteValue}} days remaining)</span></div>
    </div>
    <div>
      @if (data.isUser==='Coordinator') {
        <div>
          @if (data.projectDetails.evaluator_propose_requested) {
            <span>The evaluator has requested a {{data.projectDetails.evaluator_propose_day}} day extension for evaluation</span>
          }
          @if (!data.projectDetails.evaluator_propose_requested) {
            <span>No request from evaluator</span>
          }
        </div>
      }
      @if (data.isUser==='Evaluator') {
        <div class="extend-container-days-selection-container">
          @if (!data.projectDetails.evaluator_propose_requested) {
            <div class="extend-container-days-selection">
              <div class="extend-container-days-selection-title">Extra Days from Now</div>
              <mat-form-field>
                <mat-label>Select Days</mat-label>
                <mat-select [(ngModel)]="selectedDays">
                  @for (day of days; track day) {
                    <mat-option [value]="day">
                      {{day}}
                    </mat-option>
                  }
                </mat-select>
              </mat-form-field>
            </div>
          }
          @if (data.projectDetails.evaluator_propose_requested) {
            <div>
              The evaluator has requested a {{data.projectDetails.evaluator_propose_day}} day extension for evaluation
            </div>
          }
        </div>
      }
    </div>
    <!-- <div *ngIf="data.isUser==='Evaluator'" class="extend-container-extension-checkbox-container">
    <input type="checkbox" [(ngModel)]="allowAfterDeadline">
    Allow extension request when the deadline expires
  </div> -->
  <div class="extend-container-btn-container">
    @if (data.isUser==='Evaluator' && !data.projectDetails.evaluator_propose_requested) {
      <button [disabled]="selectedDays<=0" (click)="sendRequest()" class="btn btn-primary">
        Send Request
      </button>
    }
    @if (data.isUser==='Coordinator' && data.projectDetails.evaluator_propose_requested) {
      <button (click)="onReject()" class="btn btn-secondary">Reject</button>
    }
    @if (data.isUser==='Coordinator' && data.projectDetails.evaluator_propose_requested) {
      <button (click)="onAccept()" class="btn btn-primary">Accept</button>
    }
  </div>
</div>
</div>